import {useCookies} from '@vueuse/integrations/useCookies';

const {set: setCookie, get: getCookie} =
      useCookies(['app-font-size-variation'], {doNotParse: true});

const DEFAULT_FONT_SIZE_VARIATION = 0; // pixels font size units
const FONT_SIZE_VARIATION_STEP = 1; // pixels font size units
const MIN_SIZE_VARIATION = -3; // pixels font size units
const MAX_SIZE_VARIATION = 3; // pixels font size units

const fontSizeVariationCookieRaw = getCookie('app-font-size-variation');
const fontSizeVariationCookie = parseFloat(fontSizeVariationCookieRaw);

// #region Actions
const actions = {
  async setDefaultFontSizeVariation({dispatch}) {
    dispatch('setFontSizeVariation', {fontSizeVariation: DEFAULT_FONT_SIZE_VARIATION});
  },
  async increaseFontSizeVariation({state, dispatch}) {
    const newFontSizeVariation =
          Number(state.fontSizeVariation + FONT_SIZE_VARIATION_STEP).toFixed(0);
    dispatch('setFontSizeVariation', {fontSizeVariation: newFontSizeVariation});
  },
  async decreaseFontSizeVariation({state, dispatch}) {
    const newFontSizeVariation =
          Number(state.fontSizeVariation - FONT_SIZE_VARIATION_STEP).toFixed(0);
    dispatch('setFontSizeVariation', {fontSizeVariation: newFontSizeVariation});
  },
  async setFontSizeVariation({commit}, {fontSizeVariation}) {
    const fontSizeVariationNumber = parseInt(fontSizeVariation);
    if (fontSizeVariationNumber != null &&
        fontSizeVariationNumber >= MIN_SIZE_VARIATION &&
        fontSizeVariationNumber <= MAX_SIZE_VARIATION
    ) {
      setCookie('app-font-size-variation', fontSizeVariationNumber);
      commit('setFontSizeVariation', {fontSizeVariation: fontSizeVariationNumber});
    }
  },
  async setOverlayMinification({commit}, payload) {
    commit('setOverlayMinification', payload);
  },
  async beginPrinting({commit}) {
    commit('beginPrinting');
  },
  async endPrinting({commit}) {
    commit('endPrinting');
  },
  async setDismissableOverlay({commit}, dismissable) {
    commit('setDismissableOverlay', dismissable);
  },
};
// #endregion

// #region Getters
// #endregion

// #region Mutations
const mutations = {
  setFontSizeVariation(state, {fontSizeVariation}) {
    state.fontSizeVariation = fontSizeVariation;
    state.fontSizeVariationSource = 'user'; // Set by user
  },
  setOverlayMinification(state, payload) {
    state.overlayMinification = payload;
  },
  beginPrinting(state) {
    state.printing = true;
  },
  endPrinting(state) {
    state.printing = false;
  },
  setDismissableOverlay(state, dismissable) {
    state.dismissableOverlay = dismissable;
  },
};
// #endregion

// #region State
const state = () => {
  return {
    fontSizeVariation: !!fontSizeVariationCookie ?
      fontSizeVariationCookie : DEFAULT_FONT_SIZE_VARIATION,
    fontSizeVariationSource: !!fontSizeVariationCookie ?
      'user' : 'default', // Source of DPC data
    overlayMinification: false,
    printing: false,
    dismissableOverlay: true,
  };
};
// #endregion


// #region Etc
const namespaced = true;
const modules = []; // Submodules
// #endregion

export default {
  actions,
  // getters,
  modules,
  mutations,
  namespaced,
  state,
};
